const TermsAndConditionData = () => {
  return (
    <div>
      <div className="container-fluid  mb-5">
        <div className="container">
          <div className=" mb-5">
            <h1 className="fw-bolder text-primary">Welcome to Krent</h1>
            <div className="d-flex  row">
              {/* <p className=' col-md-9 col-lg-7'> */}
              <p className=" col-12 fw-bold">
                This website is owned and operated by Krent. By accessing or
                using this website, you agree to be bound by these terms and
                conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
      <section className="mb-5 pb-5">
        <div className="container">
          {/* <div className='  d-flex flex-column  justify-content-center col-md-9 mx-auto'> */}
          <div className="  d-flex flex-column col-12 col-md-10">
            <h6 className="fw-bold mb-2 text-primary">AGREEMENT TO TERMS</h6>
            <p className="mb-2">
              These terms of use constitute a legally binding agreement between
              you, whether personally or on behalf of an entity (“you”) and
              Krent (“we”, “us” or “our”), concerning your access to and use of
              the website [https://krent.space/] as well as any other media
              form, media channel, mobile website or mobile application related,
              linked, or otherwise connected thereto (collectively, the “Site”).
              The site enables you to list, offer, search for, buy, sell, lease
              and book services. As the provider of the platform, neither Krent
              nor its affiliates own, control, offer or manage any listings or
              services. Krent is not a party to the contracts entered into
              directly between the buyer/lessee/guest and the
              landlord/lessor/agent, nor is Krent a real estate agent/broker, or
              insurer. You agree that by accessing the Site, you have read,
              understood, and agreed to be bound by all the terms of use. If you
              do not agree with all the terms and conditions, then you are
              expressly prohibited from using the Site and you must discontinue
              use immediately. Supplemental terms or documents that may be
              posted on the Site from time to time are hereby expressly
              incorporated herein by reference. We reserve the right, in our
              sole discretion, to make changes or modifications to these terms
              and conditions at any time and for any reason. We will alert you
              about any changes by updating the “Last Updated” date on these
              terms of use, and you waive any right to receive specific notice
              of each such change. You are responsible for periodically
              reviewing these terms of use to stay informed of updates. You will
              be subject to and will be deemed to have been made aware of and to
              have accepted the changes in any revised terms of use by your
              continued use of the site after the date such revised terms and
              conditions are posted.
            </p>

            <div>
              <h6 className="text-primary mb-2 text-uppercase">
                TABLE OF CONTENTS
              </h6>

              <ol>
                <li>Buyer/Lessee/Guest Terms</li>
                <li>Landlord/Lessor Terms</li>
                <li>Agent Terms</li>
                <li>Intellectual Property Rights</li>
                <li>User Representations</li>
                <li>User Registration</li>
                <li>Prohibited Activities</li>
                <li>User-Generated Contributions</li>
                <li>Guidelines for Reviews</li>
                <li>Payment and Fees</li>
                <li>Taxes</li>
                <li>Mobile Application License</li>
                <li>Submissions</li>
                <li>Third-Party Websites and Content</li>
                <li>Advertisers</li>
                <li>Site Management</li>
                <li>Privacy Notice</li>
                <li>Copyright Infringement</li>
                <li>Term and Termination</li>
                <li>Modifications and Interruptions</li>
                <li>Governing Law</li>
                <li>Dispute Resolution</li>
                <li>Corrections</li>
                <li>Disclaimer</li>
                <li>Limitations of Liability</li>
                <li>Indemnification</li>
                <li>User Data</li>
                <li>Electronic Communications, Transactions and Signatures</li>
                <li>Miscellaneous</li>
              </ol>
            </div>
            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                Buyer/Tenant/Guest Terms
              </h4>
              <p>
                Search for Your Preferred Property: You can search for
                properties you are interested in purchasing/renting on the site.
                To find your preferred property, you can filter your search by
                choosing your preferred location, size, price, property type,
                number of bedrooms, and other amenities. Search results are
                based on properties that meet the specific criteria chosen by
                you.
              </p>
              <p>
                Availability: You can indicate your interest in any property you
                are interested in purchasing/renting. The agent/landlord will
                email you confirming the availability of the property within 48
                hours after indicating your interest.
              </p>
              <p>
                Physical Inspection: In addition to pictures, videos and 3D
                virtual tours of the property, you can request a physical
                inspection of the property. A suitable date for the physical
                inspection of the property will be agreed upon by you and the
                agent/landlord. However, nothing stops you from making payment
                for the property after the 3D virtual tour of the property.
              </p>
              <p>
                Payment: By agreeing to pay for the property, you also agree to
                pay all other ancillary fees necessary to complete the
                transaction. Payment for properties must be made via the Krent
                website, and not directly to the landlord or agent.
              </p>
              <p>
                Delivery of Property: The property will be delivered to you
                after completion of payment and the conclusion of legal
                documentation.
              </p>
              <p>
                You may not exceed the allotted duration of your lease. The
                landlord reserves the right to evict you from his property
                within the ambit of the law if you fail to leave at the
                expiration of your lease.
              </p>
              <p>
                You are not allowed to share your phone number, email address or
                account details with an agent or landlord when communicating
                with him/her via the Krent site.
              </p>
              <p>
                After making payment, you are required to provide the details of
                two guarantors or referees — one family member and one social
                contact (e.g., a colleague) — before the property is handed over
                to you.
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                Landlord Terms
              </h4>
              <p>
                Property Listing: As a landlord, Krent offers you the
                opportunity to list properties owned by you, for sale/rent at a
                price fixed by you, and in accordance with these terms and
                conditions.
              </p>
              <p>
                Availability: When you receive a request from a potential
                buyer/lessee to confirm the availability of a property you have
                listed on Krent, you should respond via email within 48 hours
                after receipt of the request, confirming the availability or
                otherwise of the said property.
              </p>
              <p>
                Physical Inspection: In accordance with these terms and
                conditions, you are at liberty to agree on a date and time with
                a potential buyer/lessee for the physical inspection of a
                property which you listed, on which interest has been indicated.
              </p>
              <p>
                Receipt of Fees: Monies accruing to you, from properties listed
                and sold/leased on the Krent site will be credited to your Krent
                wallet after the conclusion of necessary due diligence and legal
                documentation on the said property.
              </p>
              <p>
                You are not allowed to share your phone number, email address or
                account details with a potential buyer/lessee/guest when
                communicating with him/her via the Krent site.
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">Agent Terms</h4>
              <p>
                Property Listing: As an accredited agent, Krent offers you the
                opportunity to list properties on the website after verification
                and due diligence have been conducted on you and the properties
                sought to be listed, and subject to these terms and conditions.
              </p>
              <p>
                Availability: When you receive a request from a potential
                buyer/lessee/guest to confirm the availability of a property you
                listed on Krent, you should respond via email within 48 hours
                after receipt of the request, confirming the availability or
                otherwise of the property.
              </p>
              <p>
                Physical Inspection: In accordance with these terms, you are at
                liberty to agree on a date and time with a potential
                buyer/lessee/guest for the inspection of a property which you
                listed, on which interest has been indicated.
              </p>
              <p>
                Receipt of Fees: Monies accruing to you, from properties listed
                and sold/leased on the Krent site will be credited to your Krent
                wallet after the conclusion of necessary due diligence and legal
                documentation on the said property.
              </p>
              <p>
                You are not allowed to share your phone number, email address or
                account details with a potential buyer/lessee/guest when
                communicating with him/her via the Krent site.
              </p>
              <p>
                You will be required to provide the profile details — including
                the name, email address, and phone number — of the actual
                property owner.
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                Intellectual Property Rights
              </h4>
              <p>
                Unless otherwise indicated, this site is our proprietary
                property and all source code, databases, functionality,
                software, website designs, audio, video, text, photographs, and
                graphics on the Site (collectively, the “Content”) and the
                trademarks, service marks, and logos contained therein (the
                “Marks”) are owned or controlled by us or licensed to us, and
                are protected by copyright and trademark laws and various other
                intellectual property laws/rights of the Federal Republic of
                Nigeria, foreign jurisdictions, and international conventions.
              </p>
              <p>
                The Content and the Marks are provided on this site for your
                information and personal use only. Except as expressly provided
                in these Terms, no part of the Site and no Content or Marks may
                be copied, reproduced, aggregated, republished, posted, publicly
                displayed, encoded, translated, transmitted, distributed, sold,
                or otherwise exploited for any commercial purpose whatsoever,
                without our express prior written permission.
              </p>
              <p>
                Provided that you are eligible to use this Site, you are granted
                a limited license to access and use the Site and to download or
                print a copy of any portion of the Content to which you have
                properly gained access solely for your personal, non-commercial
                use. We reserve all rights not expressly granted to you in and
                to this Site, the Content, and the Marks.
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                User Representations
              </h4>
              <p>By using this Site, you represent and warrant that:</p>
              <ul>
                <li>
                  All registration information you submit will be true,
                  accurate, current, and complete;
                </li>
                <li>
                  You will maintain the accuracy of such information and
                  promptly update such information as necessary;
                </li>
                <li>
                  You have the legal capacity and you agree to comply with these
                  Terms;
                </li>
                <li>You are not under the age of 18;</li>
                <li>
                  You are not a minor in the jurisdiction in which you reside;
                </li>
                <li>
                  You will not access this Site through automated or non-human
                  means, whether through a bot, script, or otherwise;
                </li>
                <li>
                  You will not use the Site for any illegal or unauthorized
                  purpose;
                </li>
                <li>
                  Your use of the Site will not violate any applicable law or
                  regulation.
                </li>
              </ul>
              <p>
                If you provide any information that is untrue, inaccurate, not
                current, or incomplete, we have the right to suspend or
                terminate your access and refuse any current or future use of
                this Site (or any portion thereof).
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                User Registration
              </h4>
              <p>
                You may be required to register with this Site. You agree to
                keep your password confidential and will be responsible for all
                use of your account and password. We reserve the right to
                remove, reclaim, or change a username you select if we
                determine, in our sole discretion, that such a username is
                inappropriate, obscene, or otherwise objectionable.
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                Prohibited Activities
              </h4>
              <p>
                You may not access or use the Site for any purpose other than
                that for which we make this Site available. This Site may not be
                used in connection with any commercial endeavours except those
                that are specifically endorsed or approved by us. As a user of
                this Site, you agree not to:
              </p>
              <ul>
                <li>
                  Systematically retrieve data or other content from the Site to
                  create or compile, directly or indirectly, a collection,
                  compilation, database, or directory without written permission
                  from us.
                </li>
                <li>
                  Make any unauthorized use of this Site, including collecting
                  usernames and/or email addresses of users by electronic or
                  other means to send unsolicited emails, or create user
                  accounts by automated means or under false pretenses.
                </li>
                <li>
                  Circumvent, disable, or otherwise interfere with
                  security-related features of this Site, including features
                  that prevent or restrict the use or copying of any Content or
                  enforce limitations on the use of this Site and/or the Content
                  contained therein.
                </li>
                <li>
                  Engage in unauthorized framing of or linking to the Site.
                </li>
                <li>
                  Trick, defraud, or mislead us and other users, especially in
                  any attempt to learn sensitive account information such as
                  user passwords.
                </li>
                <li>
                  Make improper use of our support services or submit false
                  reports of abuse or misconduct.
                </li>
                <li>
                  Engage in any automated use of the system, such as using
                  scripts to send comments or messages, or using any data
                  mining, robots, or similar data gathering and extraction
                  tools.
                </li>
                <li>
                  Interfere with, disrupt, or create an undue burden on the Site
                  or the networks or services connected to this Site.
                </li>
                <li>
                  Attempt to impersonate another user or person or use the
                  username of another user.
                </li>
                <li>Sell or otherwise transfer your profile.</li>
                <li>
                  Use any information obtained from this Site to harass, abuse,
                  or harm another person.
                </li>
                <li>Use this Site as part of any effort to compete with us.</li>
                <li>
                  Decipher, decompile, disassemble, or reverse engineer any of
                  the software comprising or in any way making up a part of this
                  Site.
                </li>
                <li>
                  Attempt to bypass any measures of this Site designed to
                  prevent or restrict access to this Site, or any portion of
                  this Site.
                </li>
                <li>
                  Harass, annoy, intimidate, or threaten any of our employees or
                  agents engaged in providing any service of the company to you
                  via this Site.
                </li>
                <li>
                  Delete the copyright or other proprietary rights notice from
                  any Content.
                </li>
                <li>
                  Copy or adapt the Site’s software, including but not limited
                  to Flash, PHP, HTML, JavaScript, or other code.
                </li>
                <li>
                  Upload or transmit (or attempt to upload or to transmit)
                  viruses, Trojan horses, or other material, including excessive
                  use of capital letters and spamming, that interferes with any
                  party’s uninterrupted use and enjoyment of the Site or
                  modifies, impairs, disrupts, alters, interferes with the use,
                  functions, operation, or maintenance of the Site.
                </li>
                <li>
                  Upload or transmit (or attempt to upload or to transmit) any
                  material that acts as a passive or active information
                  collection or transmission mechanism.
                </li>
                <li>
                  Except as may be the result of standard search engine or
                  Internet browser usage, use, launch, develop, or distribute
                  any automated system, including without limitation any spider,
                  robot, cheat utility, scraper, or offline reader that accesses
                  the Site, or using or launching any unauthorized script or
                  other software.
                </li>
                <li>
                  Disparage, tarnish, or otherwise harm, in our opinion, us
                  and/or the Site.
                </li>
                <li>
                  Use the Site in a manner inconsistent with any applicable laws
                  or regulations.
                </li>
              </ul>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                User-Generated Contributions
              </h4>
              <p>
                The Site may invite you to chat, contribute to, or participate
                in blogs, message boards, online forums, and other
                functionality...
              </p>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                Guidelines for Reviews
              </h4>
              <p>
                We may provide you with areas on the Site to leave reviews or
                ratings. When posting a review, you must comply with the
                following criteria:
              </p>
              <ul>
                <li>
                  You should have firsthand experience with the person/entity
                  being reviewed;
                </li>
                <li>
                  Your reviews should not contain offensive, abusive, racist, or
                  hate language;
                </li>
                <li>
                  Your reviews should not contain discriminatory references...
                </li>
              </ul>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">
                Payment and Fees
              </h4>
              <p>
                In addition to the fees that may be fixed by the landlord or
                agent, you also agree to pay:
              </p>
              <ul>
                <li>5% of the value of the property as legal fee</li>
                <li>
                  8% of the value of the property as an administrative fee
                </li>
              </ul>
            </section>

            <section>
              <h4 className="text-primary mb-2 text-uppercase">Taxes</h4>
              <p>
                Each party is responsible for the payment of taxes due to the
                necessary government authorities as ascribed to him by
                applicable laws.
              </p>
            </section>
            <h5 className="text-primary mb-2 text-uppercase">
              MOBILE APPLICATION LICENSE
            </h5>

            <h6>Use License</h6>
            <p>
              If you access the Site via a mobile application, then we grant you
              a revocable, non-exclusive, non-transferable, limited right to
              install and use the mobile application on wireless electronic
              devices owned or controlled by you and to access and use the
              mobile application on such devices strictly by the terms and
              conditions of this mobile application license contained in these
              Terms and Conditions.
            </p>

            <p>You shall not:</p>
            <ul>
              <li>
                decompile, reverse engineer, disassemble, attempt to derive the
                source code of, or decrypt the application;
              </li>
              <li>
                make any modification, adaptation, improvement, enhancement,
                translation, or derivative work from the application;
              </li>
              <li>
                violate any applicable laws, rules, or regulations in connection
                with your access or use of the application;
              </li>
              <li>
                remove, alter, or obscure any proprietary notice (including any
                notice of copyright or trademark) posted by us or the licensors
                of the application;
              </li>
              <li>
                use the application for any revenue-generating endeavour,
                commercial enterprise, or other purpose for which it is not
                designed or intended;
              </li>
              <li>
                make the application available over a network or other
                environment permitting access or use by multiple devices or
                users at the same time;
              </li>
              <li>
                use the application for creating a product, service, or software
                that is, directly or indirectly, competitive with or in any way
                a substitute for the application;
              </li>
              <li>
                use the application to send automated queries to any website or
                to send any unsolicited commercial e-mail;
              </li>
              <li>
                use any proprietary information or any of our interfaces or our
                other intellectual property in the design, development,
                manufacture, licensing, or distribution of any applications,
                accessories, or devices for use with the application.
              </li>
            </ul>

            <h6>Apple and Android Devices</h6>
            <p>
              The following terms apply when you use a mobile application
              obtained from either the Apple Store or Google Play (each an “App
              Distributor”) to access the Site:
            </p>
            <ul>
              <li>
                the license granted to you for our mobile application is limited
                to a non-transferable license to use the application on a device
                that utilizes the Apple iOS or Android operating systems, as
                applicable, and by the usage rules outlined in the applicable
                App Distributor’s terms and conditions;
              </li>
              <li>
                we are responsible for providing any maintenance and support
                services concerning the mobile application as specified in the
                terms and conditions of this mobile application license
                contained in these Terms and Conditions or as otherwise required
                under applicable law, and you acknowledge that each App
                Distributor has no obligation whatsoever to furnish any
                maintenance and support services concerning the mobile
                application;
              </li>
              <li>
                in the event of any failure of the mobile application to conform
                to any applicable warranty, you may notify the applicable App
                Distributor, and the App Distributor, by its terms and policies,
                may refund the purchase price, if any, paid for the mobile
                application, and to the maximum extent permitted by applicable
                law, the App Distributor will have no other warranty obligation
                whatsoever concerning the mobile application;
              </li>
              <li>
                you must comply with applicable third-party terms of agreement
                when using the mobile application;
              </li>
              <li>
                you acknowledge and agree that the App Distributors are
                third-party beneficiaries of the terms and conditions in this
                mobile application license contained in these Terms and
                Conditions, and that each App Distributor will have the right
                (and will be deemed to have accepted the right) to enforce the
                terms and conditions in this mobile application license
                contained in these Terms and Conditions against you as a
                third-party beneficiary thereof.
              </li>
            </ul>

            <h5 className="text-primary mb-2 text-uppercase">SUBMISSIONS</h5>
            <p>
              You acknowledge and agree that any questions, comments,
              suggestions, ideas, feedback, or other information regarding the
              Site (“Submissions”) provided by you to us are non-confidential
              and shall become our sole property. We shall have exclusive
              rights, including all intellectual property rights, and shall be
              entitled to the unrestricted use and dissemination of these
              Submissions for any lawful purpose, commercial or otherwise,
              without acknowledgement or compensation to you.
            </p>
            <p>
              You hereby waive all moral rights to any such Submissions, and you
              hereby warrant that any such Submissions are original with you or
              that you have the right to submit such Submissions. You agree
              there shall be no recourse against us for any alleged or actual
              infringement or misappropriation of any proprietary right in your
              Submissions.
            </p>
            <h5 className="text-primary mb-2 text-uppercase">
              THIRD-PARTY WEBSITES AND CONTENT
            </h5>
            <p>
              The Site may contain (or you may be sent via the Site) links to
              other websites (“Third-Party Websites”) as well as articles,
              photographs, text, graphics, pictures, designs, music, sound,
              video, information, applications, software, and other content or
              items belonging to or originating from third parties (“Third-Party
              Content”).
            </p>
            <p>
              Such Third-Party Websites and Third-Party Content are not
              investigated, monitored, or checked for accuracy, appropriateness,
              or completeness by us, and we are not responsible for any
              Third-Party Websites accessed through the Site or any Third-Party
              Content posted on, available through, or installed from the Site,
              including the content, accuracy, offensiveness, opinions,
              reliability, privacy practices, or other policies of or contained
              in the Third-Party Websites or the Third-Party Content.
            </p>
            <p>
              Inclusion of, linking to, or permitting the use or installation of
              any Third-Party Websites or any Third-Party Content does not imply
              approval or endorsement thereof by us. If you decide to leave the
              Site and access the Third-Party Websites or to use or install any
              Third-Party Content, you do so at your own risk, and you should be
              aware these Terms and Conditions no longer govern.
            </p>
            <p>
              You should review the applicable terms and policies, including
              privacy and data gathering practices, of any website to which you
              navigate from the Site or relating to any applications you use or
              install from the Site. Any purchases you make through Third-Party
              Websites will be through other websites and from other companies,
              and we take no responsibility whatsoever for such purchases which
              are exclusively between you and the applicable third party.
            </p>
            <p>
              You agree and acknowledge that we do not endorse the products or
              services offered on Third-Party Websites and you shall hold us
              harmless from any harm caused by your purchase of such products or
              services. Additionally, you shall hold us harmless from any losses
              sustained by you or harm caused to you relating to or resulting in
              any way from any Third-Party Content or any contact with
              Third-Party Websites.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">ADVERTISERS</h5>
            <p>
              We allow advertisers to display their advertisements and other
              information in certain areas of the Site, such as sidebar
              advertisements or banner advertisements. If you are an advertiser,
              you shall take full responsibility for any advertisements you
              place on the Site and any services provided on the Site or
              products sold through those advertisements.
            </p>
            <p>
              Further, as an advertiser, you warrant and represent that you
              possess all rights and authority to place advertisements on the
              Site, including, but not limited to, intellectual property rights,
              publicity rights, and contractual rights.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">
              SITE MANAGEMENT
            </h5>
            <p>We reserve the right, but not the obligation, to:</p>
            <ul>
              <li>
                monitor the Site for violations of these Terms and Conditions;
              </li>
              <li>
                take appropriate legal action against anyone who, in our sole
                discretion, violates the law or these Terms and Conditions,
                including without limitation, reporting such user to law
                enforcement authorities;
              </li>
              <li>
                in our sole discretion and without limitation, refuse, restrict
                access to, limit the availability of, or disable (to the extent
                technologically feasible) any of your Contributions or any
                portion thereof;
              </li>
              <li>
                in our sole discretion and without limitation, notice, or
                liability, to remove from the Site or otherwise disable all
                files and content that are excessive in size or are in any way
                burdensome to our systems;
              </li>
              <li>
                otherwise, manage the Site in a manner designed to protect our
                rights and property and to facilitate the proper functioning of
                the Site.
              </li>
            </ul>

            <h5 className="text-primary mb-2 text-uppercase">PRIVACY POLICY</h5>
            <p>
              We care about data privacy and security. Please review our Privacy
              Policy. By using the Site, you agree to be bound by our Privacy
              Policy, which is incorporated into these Terms and Conditions.
            </p>
            <h5 className="text-primary mb-2 text-uppercase">
              COPYRIGHT INFRINGEMENTS
            </h5>
            <p>
              We respect the intellectual property rights of others. If you
              believe that any material available on or through the Site
              infringes upon any copyright you own or control, please
              immediately notify us using the contact information provided below
              (a “Notification”). A copy of your Notification will be sent to
              the person who posted or stored the material addressed in the
              Notification.
            </p>
            <p>
              Please be advised that under applicable law you may be held liable
              for damages if you make material misrepresentations in a
              Notification. Thus, if you are not sure that the material located
              on or linked to by the Site infringes your copyright, you should
              consider first contacting a lawyer.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">TERMINATION</h5>
            <p>
              These Terms and Conditions shall remain in full force and effect
              while you use the Site. Without limiting any other provision of
              these terms and conditions, we reserve the right to, in our sole
              discretion and without notice or liability, deny access to and use
              of the site (including blocking certain IP addresses), to any
              person for any reason, including without limitation for breach of
              any representation, warranty, or covenant contained in these terms
              and conditions or of any applicable law or regulation.
            </p>
            <p>
              We may terminate your use or participation in the site or delete
              your account and any content or information that you posted at any
              time, without warning, in our sole discretion.
            </p>
            <p>
              If we terminate or suspend your account for any reason, you are
              prohibited from registering and creating a new account under your
              name, a fake or borrowed name, or the name of any third party,
              even if you may be acting on behalf of the third party.
            </p>
            <p>
              In addition to terminating or suspending your account, we reserve
              the right to take appropriate legal action, including without
              limitation pursuing civil, criminal, and injunctive redress.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">
              MODIFICATIONS AND INTERRUPTIONS
            </h5>
            <p>
              We reserve the right to change, modify, or remove the contents of
              the Site at any time or for any reason at our sole discretion
              without notice. However, we have no obligation to update any
              information on our Site. We also reserve the right to modify or
              discontinue all or part of the Site without notice at any time.
            </p>
            <p>
              We will not be liable to you or any third party for any
              modification, price change, suspension, or discontinuation of the
              Site.
            </p>
            <p>
              We cannot guarantee the Site will always be available. We may
              experience hardware, software, or other problems or need to
              perform maintenance related to the Site, resulting in
              interruptions, delays, or errors.
            </p>
            <p>
              We reserve the right to change, revise, update, suspend,
              discontinue, or otherwise modify the Site at any time or for any
              reason without notice to you. You agree that we have no liability
              whatsoever for any loss, damage, or inconvenience caused by your
              inability to access or use the Site during any downtime or
              discontinuation of the Site.
            </p>
            <p>
              Nothing in these Terms and Conditions will be construed to oblige
              us to maintain and support the Site or to supply any corrections,
              updates, or releases in connection therewith.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">GOVERNING LAW</h5>
            <p>
              These Terms and Conditions and your use of the Site are governed
              by and construed by the laws of the Federal Republic of Nigeria
              applicable to agreements made and to be entirely performed within
              Nigeria, without regard to its conflict of law principles.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">
              DISPUTE RESOLUTION
            </h5>
            <p>
              Any dispute arising out of or in connection with this Agreement,
              including any question regarding its existence, validity, or
              termination, shall be referred to and finally resolved by
              arbitration under the Arbitration and Mediation Act, 2023, which
              Rules are deemed to be incorporated by reference into this clause,
              except where specifically excluded.
            </p>
            <p>
              The seat of arbitration shall be Nigeria and the venue shall be
              Abuja.
            </p>
            <p>The language of the arbitral proceeding shall be English.</p>
            <p>
              The arbitral award shall be final and binding on the Parties and
              may be enforceable by a court of competent jurisdiction except in
              the case of fraud, gross mistake, or abuse of process.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">CORRECTIONS</h5>
            <p>
              There may be information on the Site that contains typographical
              errors, inaccuracies, or omissions that may relate to the Site,
              including descriptions, pricing, availability, and various other
              information. We reserve the right to correct any errors,
              inaccuracies, or omissions and to change or update the information
              on the Site at any time, without prior notice.
            </p>

            <h5 className="text-primary mb-2 text-uppercase">DISCLAIMER</h5>
            <p>
              You agree that your use of the site and our services will be at
              your sole risk. To the fullest extent permitted by law, we
              disclaim all warranties, express or implied, in connection with
              the site and your use thereof, including, without limitation, the
              implied warranties of merchantability, fitness for a particular
              purpose, and non-infringement.
            </p>
            <p>
              We make no warranties or representations about the accuracy or
              completeness of the site’s content, or the content of any websites
              linked to the site, and we will assume no liability or
              responsibility for any:
            </p>
            <ul>
              <li>
                errors, mistakes, or inaccuracies of content and materials,
              </li>
              <li>
                personal injury or property damage, of any nature whatsoever,
                resulting from your access to and use of the site,
              </li>
              <li>
                any unauthorized access to or use of our secure servers and/or
                any personal information and/or financial information stored
                therein,
              </li>
              <li>
                any interruption or cessation of transmission to or from the
                site,
              </li>
              <li>
                any bugs, viruses, trojan horses, or the like which may be
                transmitted to or through the site by any third party, and/or
              </li>
              <li>
                any errors or omissions in any content and materials or for any
                loss or damage of any kind incurred as a result of the use of
                any content posted, transmitted, or otherwise made available via
                the site.
              </li>
            </ul>
            <p>
              We do not warrant, endorse, guarantee, or assume responsibility
              for any product or service advertised or offered by a third party
              through the site, any hyperlinked website, or any website or
              mobile application featured in any banner or other advertising,
              and we will not be a party to or in any way be responsible for
              monitoring any transaction between you and any third-party
              providers of products or services.
            </p>
            <p>
              As with the purchase of a product or service through any medium or
              in any environment, you should use your best judgment and exercise
              caution where appropriate.
            </p>
            <div>
              <h5 className="text-primary mb-2 text-uppercase">
                LIMITATIONS OF LIABILITY
              </h5>
              <p>
                In no event will we or our directors, employees, or agents be
                liable to you or any third party for any direct, indirect,
                consequential, exemplary, incidental, special, or punitive
                damages, including lost profit, lost revenue, loss of data, or
                other damages arising from your use of the site, even if we have
                been advised of the possibility of such damages.
              </p>

              <h5 className="text-primary mb-2 text-uppercase">
                INDEMNIFICATION
              </h5>
              <p>
                You agree to defend, indemnify, and hold us harmless, including
                our subsidiaries, affiliates, and all of our respective
                officers, agents, partners, and employees, from and against any
                loss, damage, liability, claim, or demand, including reasonable
                lawyers’ fees and expenses, made by any third party due to or
                arising out of (1) your Contributions; (2) use of the Site; (3)
                breach of these Terms and Conditions; (4) any breach of your
                representations and warranties outlined in these Terms and
                Conditions; (5) your violation of the rights of a third party,
                including but not limited to intellectual property rights; or
                (6) any overt harmful act toward any other user of the Site with
                whom you connected via the Site.
              </p>
              <p>
                Notwithstanding the foregoing, we reserve the right, at your
                expense, to assume the exclusive defence and control of any
                matter for which you are required to indemnify us, and you agree
                to cooperate, at your expense, with our defence of such claims.
                We will use reasonable efforts to notify you of any such claim,
                action, or proceeding which is subject to this indemnification
                upon becoming aware of it.
              </p>

              <h5 className="text-primary mb-2 text-uppercase">USER DATA</h5>
              <p>
                We will maintain certain data that you transmit to the Site to
                manage the Site, as well as data relating to your use of the
                Site. Although we perform routine backups of data, you are
                solely responsible for all data that you transmit or that
                relates to any activity you have undertaken using the Site.
              </p>
              <p>
                You agree that we shall incur no liability for any loss or
                corruption of any such data, and you hereby waive any right of
                action against us arising from any such loss or corruption of
                such data.
              </p>

              <h5 className="text-primary mb-2 text-uppercase">
                ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
              </h5>
              <p>
                Visiting the Site, sending us emails, and completing online
                forms constitute electronic communications. You consent to
                receive electronic communications, and you agree that all
                agreements, notices, disclosures, and other communications we
                provide to you electronically, via email and on the Site,
                satisfy any legal requirement that such communication be in
                writing.
              </p>
              <p>
                You hereby agree to the use of electronic signatures, contracts,
                orders, and other records, and the electronic delivery of
                notices, policies, and records of transactions initiated or
                completed by us or via the site.
              </p>
              <p>
                You hereby waive any rights or requirements under any statutes,
                regulations, rules, ordinances, or other laws in any
                jurisdiction which require an original signature or delivery or
                retention of non-electronic records, or payments or the granting
                of credits by any means other than electronic means.
              </p>

              <h5 className="text-primary mb-2 text-uppercase">
                MISCELLANEOUS
              </h5>
              <p>
                These Terms and Conditions and any policies or operating rules
                posted by us on the Site constitute the entire agreement and
                understanding between you and us. Our failure to exercise or
                enforce any right or provision of these Terms and Conditions
                shall not operate as a waiver of such right or provision.
              </p>
              <p>
                These Terms and Conditions operate to the fullest extent
                permissible by law. We may assign any or all our rights and
                obligations to others at any time. We shall not be responsible
                or liable for any loss, damage, delay, or failure to act caused
                by any cause beyond our reasonable control.
              </p>
              <p>
                If any provision or part of a provision of these Terms and
                Conditions is determined to be unlawful, void, or unenforceable,
                that provision or part of the provision is deemed severable from
                these Terms and Conditions and does not affect the validity and
                enforceability of any remaining provisions.
              </p>
              <p>
                There is no joint venture, partnership, employment, or agency
                relationship created between you and us as a result of these
                Terms and Conditions or use of the Site. You agree that these
                Terms and Conditions will not be construed against us by having
                drafted them.
              </p>
              <p>
                You hereby waive any defences you may have based on the
                electronic form of these Terms and Conditions and the lack of
                signing by the parties hereto to execute these Terms and
                Conditions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default TermsAndConditionData;
